export default "__VITE_ASSET__DnLCgTkK__"